function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PHASE = {
  CONFIRMING: 'confirming',
  COMPLETE: 'complete',
  DISMISSED: 'dismissed'
};
var _require = require('saito-js/lib/slip'),
  SlipType = _require.SlipType;

/**
 * Progress tracking for an in-flight listing broadcast.
 * Does not fabricate or inject listing teaser / Summary objects —
 * warehouse inventory is the source of truth after confirmation.
 */
var ListingLifecycle = /*#__PURE__*/function () {
  function ListingLifecycle(app, mod) {
    var _this = this;
    _classCallCheck(this, ListingLifecycle);
    this.app = app;
    this.mod = mod;
    this.listings = [];
    this.app.connection.on('store-list-asset', function (data) {
      _this.onStoreListAsset(data);
    });
    this.app.connection.on('store-new-block', function () {
      _this.emitActive();
    });
  }

  /**
   * Begin tracking a listing after the tx is broadcast (progress UI only).
   */
  return _createClass(ListingLifecycle, [{
    key: "begin",
    value: function begin() {
      var _listingTx$from, _listingTx$from2;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$nft = _ref.nft,
        nft = _ref$nft === void 0 ? null : _ref$nft,
        _ref$listing = _ref.listing,
        listing = _ref$listing === void 0 ? {} : _ref$listing,
        _ref$listingTx = _ref.listingTx,
        listingTx = _ref$listingTx === void 0 ? null : _ref$listingTx,
        _ref$sellerPublicKey = _ref.sellerPublicKey,
        sellerPublicKey = _ref$sellerPublicKey === void 0 ? '' : _ref$sellerPublicKey;
      var signature = (listingTx === null || listingTx === void 0 ? void 0 : listingTx.signature) || '';
      var nft_id = String((nft === null || nft === void 0 ? void 0 : nft.id) || (nft === null || nft === void 0 ? void 0 : nft.uuid) || (listing === null || listing === void 0 ? void 0 : listing.nft_id) || '').trim();
      if (!signature || !nft_id) {
        return null;
      }

      // Bound from[0] is mint creator metadata; ownership is Normal/ATR from[1].
      var from0 = listingTx === null || listingTx === void 0 || (_listingTx$from = listingTx.from) === null || _listingTx$from === void 0 ? void 0 : _listingTx$from[0];
      var from1 = listingTx === null || listingTx === void 0 || (_listingTx$from2 = listingTx.from) === null || _listingTx$from2 === void 0 ? void 0 : _listingTx$from2[1];
      var listing_seller = (from0 === null || from0 === void 0 ? void 0 : from0.publicKey) || '';
      if ((from0 === null || from0 === void 0 ? void 0 : from0.type) === SlipType.Bound && from1 !== null && from1 !== void 0 && from1.publicKey) {
        listing_seller = from1.publicKey;
      }
      var seller = String(sellerPublicKey || this.mod.publicKey || '').trim() || listing_seller || '';
      var title = String(listing.title || (nft === null || nft === void 0 ? void 0 : nft.title) || 'Untitled Item').trim();
      var entry = {
        id: "".concat(signature, ":").concat(Date.now()),
        nft_id: nft_id,
        seller: seller,
        listing_signature: signature,
        title: title,
        phase: PHASE.CONFIRMING,
        status: 'Listing Submitted',
        detail: 'Waiting for confirmation…',
        started_at: Date.now(),
        completed_at: 0
      };
      this.listings.push(entry);
      this.emit(entry);
      if (typeof siteMessage === 'function') {
        siteMessage("Listing submitted: ".concat(title), 4000);
      }
      return entry;
    }
  }, {
    key: "findById",
    value: function findById() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.listings.find(function (l) {
        return l.id === id;
      }) || null;
    }
  }, {
    key: "findByListingTx",
    value: function findByListingTx() {
      var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!signature) {
        return null;
      }
      return this.listings.find(function (l) {
        return l.listing_signature === signature && l.phase !== PHASE.DISMISSED;
      }) || null;
    }
  }, {
    key: "returnActiveListing",
    value: function returnActiveListing() {
      var pending = this.listings.find(function (l) {
        return l.phase === PHASE.CONFIRMING;
      });
      if (pending) {
        return pending;
      }
      return this.listings.find(function (l) {
        return l.phase === PHASE.COMPLETE;
      }) || null;
    }
  }, {
    key: "setPhase",
    value: function setPhase(id, phase) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref2$status = _ref2.status,
        status = _ref2$status === void 0 ? '' : _ref2$status,
        _ref2$detail = _ref2.detail,
        detail = _ref2$detail === void 0 ? '' : _ref2$detail;
      var entry = this.findById(id);
      if (!entry) {
        return null;
      }
      entry.phase = phase;
      if (status) {
        entry.status = status;
      }
      if (detail) {
        entry.detail = detail;
      }
      if (phase === PHASE.COMPLETE) {
        entry.completed_at = Date.now();
      }
      this.emit(entry);
      return entry;
    }
  }, {
    key: "markConfirmed",
    value: function markConfirmed() {
      var listingTxSignature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var entry = this.findByListingTx(listingTxSignature);
      if (!entry) {
        return null;
      }
      if (entry.phase === PHASE.COMPLETE || entry.phase === PHASE.DISMISSED) {
        return entry;
      }
      var updated = this.setPhase(entry.id, PHASE.COMPLETE, {
        status: 'Listing Published',
        detail: 'Your NFT is now available in your Store.'
      });
      if (typeof siteMessage === 'function') {
        siteMessage("Listing published: ".concat(entry.title), 5000);
      }
      this.app.connection.emit('store-render-listings');
      return updated;
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var entry = id ? this.findById(id) : this.returnActiveListing();
      if (!entry) {
        return null;
      }
      return this.setPhase(entry.id, PHASE.DISMISSED, {
        status: '',
        detail: ''
      });
    }
  }, {
    key: "onStoreListAsset",
    value: function onStoreListAsset() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        tx = _ref3.tx,
        conf = _ref3.conf;
      if (Number(conf) !== 0 || !(tx !== null && tx !== void 0 && tx.signature)) {
        return;
      }
      var txmsg = typeof tx.returnMessage === 'function' ? tx.returnMessage() : null;
      if (!txmsg || txmsg.module !== 'Store' || txmsg.request !== 'list-asset') {
        return;
      }
      if (txmsg.fulfill_sale) {
        return;
      }
      this.markConfirmed(tx.signature);
    }
  }, {
    key: "emitActive",
    value: function emitActive() {
      var active = this.returnActiveListing();
      if (active) {
        this.emit(active);
      }
    }
  }, {
    key: "emit",
    value: function emit(entry) {
      this.app.connection.emit('store-listing-lifecycle', entry);
    }
  }]);
}();
ListingLifecycle.PHASE = PHASE;
module.exports = ListingLifecycle;